
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/partner-program/hris-onboarding",
      function () {
        return require("private-next-pages/developers/partner-program/hris-onboarding.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/partner-program/hris-onboarding"])
      });
    }
  